export const MplusStatuses = {
  NOT_ALLOW: {
    key: 'NOT_ALLOW', // не отображать мплюс
  },
  INCLUDE: {
    key: 'INCLUDE', // возможность открыть мплюс
  },
  NOT_ALLOW_MPLUS: {
    key: 'NOT_ALLOW_MPLUS', // не доступен мплюс
  },
  NOT_ALLOW_PRICE: {
    key: 'NOT_ALLOW_PRICE', // сумма меньше чем 500
  },
  NOT_ENOUGH_CASH: {
    key: 'NOT_ENOUGH_CASH', // сумма мплюса меньше чем требуется
  },
  ALLOW: {
    key: 'ALLOW', //доступен мплюс
  },
} as const

export type MplusStatusesTypes = keyof typeof MplusStatuses

export enum TypePayment {
  Mplus = 'Mplus',
  Regular = 'Regular',
  MInstallment = 'MInstalment',
}
